import styled from 'styled-components';
import { Button } from 'components/elements';

const StyledParentalControlButton = styled(Button)`
	margin: 0 auto;
`;

export default StyledParentalControlButton;
